module.exports = {
  "servers": ['127.0.0.1:11211'],
  "poolSize": 50,
  "timeout": 1000,
  "retries": 1,
  "failures": 1,
  "duration": 120,
  "namespace": ''
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/http-memoizr/src/config.js
 ** module id = 552
 ** module chunks = 0
 **/